import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../Hooks/useAuth";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import AlertField from "./AlertField";
import ConfirmationModal from "./ConfirmationModal";

const DeleteAccount = () => {
  const { auth, setAuth } = useAuth();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  const onDelete = async () => {
    try {
      await axiosPrivate.delete(`auth/delete/${auth?.user?.id}/`);

      setAuth({});
      navigate("/login", {
        state: {
          message: "Account Deleted.",
          type: "success",
        },
      });
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else {
        showAlert("Deletion Failed", "warning");
      }
    }

    //closes the modal form
    document.getElementById(`confirmationModal${auth?.user?.id}-close`).click();
  };

  return (
    <>
      <AlertField alert={alert} />
      <div className="mx-5 mt-2 mb-4">
        <h2 className="text-danger">Delete Account</h2>
        <hr />
        <p>
          Once you delete your account, there is no going back. Please be
          certain.
        </p>
        <ConfirmationModal
          button="Delete"
          target={`confirmationModal${auth?.user?.id}`}
          btnClass="btn btn-danger px-5"
          title="Delete Confirmation"
          body="Are you sure you want to delete your account?. There is no coming back."
          close="No"
          save="Yes"
          onClick={onDelete}
        />
      </div>
    </>
  );
};

export default DeleteAccount;
